<div fxLayout="column" fxLayoutGap="15px" fxFlex="100">
  <div fxLayout="row">
    <h3>Wynik</h3>
  </div>

  <app-detail fxFlex="100" header="Brakujące dane">
    <ng-container *ngFor="let text of import.result.emptyData; let last = last">
      {{text}}<ng-container *ngIf="!last">,<br></ng-container>
    </ng-container>
  </app-detail>

  <app-detail fxFlex="100" header="Nieznaleziona OFWCA zawierająca polisę">
    <ng-container *ngFor="let text of import.result.notFoundOfwca; let last = last">
      {{text}}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </app-detail>

  <app-detail fxFlex="100" header="Nieznaleziona OFWCA na którą przepinamy">
    <ng-container *ngFor="let text of import.result.notFoundNewOfwca; let last = last">
      {{text}}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </app-detail>

  <app-detail fxFlex="100" header="OFWCA bez umowy">
    <ng-container *ngFor="let text of import.result.notFoundContract; let last = last">
      {{text}}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </app-detail>

  <app-detail fxFlex="100" header="Duplikaty identyfikatorów">
    <ng-container *ngFor="let text of import.result.duplicatedId; let last = last">
      {{text}}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </app-detail>

  <app-detail fxFlex="100" header="Duplikaty nr polis">
    <ng-container *ngFor="let text of import.result.alreadyExistsPolicyNumber; let last = last">
      {{text}}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </app-detail>

</div>
